import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingExclusion } from './types/Listing';
import { ListingExclusionsResponse } from './getListingExclusions';

interface ListingExclusionsPayload {
  dates: ListingExclusion[];
  adjustDates?: boolean;
  actionToken?: string;
}

const addListingExclusions =
  (makeCall: MakeCall) =>
  (
    listingId: number,
    { dates, adjustDates = true, actionToken }: ListingExclusionsPayload,
  ) =>
    makeCall<ListingExclusionsResponse>(
      'POST',
      `/api/v2/listing/${listingId}/exclusions`,
      {
        data: {
          dates,
          adjustDates,
          actionToken,
        },
      },
    );

export default addListingExclusions;
